// Mock data for SAI Industries website

export const companyInfo = {
  name: "SAI INDUSTRIES",
  tagline: "Excellence in Flameproof Electrical Equipment",
  description: "Leading manufacturer of certified flameproof electrical equipment for hazardous environments. Committed to safety, quality, and innovation since establishment.",
  email: "info@saiex.co.in",
  phone: "+91 7490 007 991",
  phone2: "+91 7490 006 991",
  address: "Plot No. 4709, Plastic Zone, G.I.D.C., Sarigam, Valsad, Gujarat- 396155"
};

export const products = [
  {
    id: 1,
    name: "Flameproof LED Well Glass / Flood Light",
    description: "High-performance LED lighting solutions for hazardous areas up to 150 Watt capacity.",
    features: ["Up to 150W LED", "Zone 1 & 2", "Gas Group IIA, IIB & IIC", "IP66 Protection", "Temperature Class T6"],
    image: "https://customer-assets.emergentagent.com/job_sai-electrical/artifacts/erzde4xz_IMG-20230521-WA0025-PhotoRoom.png-PhotoRoom.png",
    catNo: "SAI/3011"
  },
  {
    id: 2,
    name: "Flameproof Junction Boxes",
    description: "Robust junction boxes designed for explosive atmospheres with multiple size options.",
    features: ["120mm to 300mm Dia", "Zone 1 & 2", "Gas Group IIA, IIB & IIC", "IP66 Protection", "Spigot/Flange Type"],
    image: "https://customer-assets.emergentagent.com/job_sai-electrical/artifacts/o7w0vsfq_IMG-20230521-WA0032-PhotoRoom.png-PhotoRoom.png",
    catNo: "SAI/JB/1001"
  },
  {
    id: 3,
    name: "Flameproof Push Button Stations",
    description: "Explosion-proof control stations with various configurations for hazardous areas.",
    features: ["On/Off Type Available", "Zone 1 & 2", "Gas Group IIA, IIB & IIC", "IP66 Protection", "With Indicator Option"],
    image: "https://customer-assets.emergentagent.com/job_sai-electrical/artifacts/zo7j90m8_IMG-20230521-WA0037-PhotoRoom.png-PhotoRoom.png",
    catNo: "SAI/PBS/1050"
  },
  {
    id: 4,
    name: "Flameproof Control Panels",
    description: "Customizable flameproof control panels for comprehensive industrial automation.",
    features: ["Multiple Sizes", "MCB/MCCB Options", "Zone 1 & 2", "IP65 Protection", "Customizable Design"],
    image: "https://customer-assets.emergentagent.com/job_sai-electrical/artifacts/sg47pmfo_IMG-20230521-WA0049-PhotoRoom.png-PhotoRoom.png",
    catNo: "SAI/RCP/1055"
  },
  {
    id: 5,
    name: "Flameproof Switch Socket",
    description: "Heavy-duty explosion-proof plug and socket for hazardous industrial environments.",
    features: ["Up to 63 Amp", "Zone 1 & 2", "Gas Group IIA, IIB & IIC", "IP66 Protection", "Chain Safety Lock"],
    image: "https://customer-assets.emergentagent.com/job_sai-electrical/artifacts/5us4h4pg_IMG-20230521-WA0014-PhotoRoom.png-PhotoRoom.png",
    catNo: "SAI/1059"
  },
  {
    id: 6,
    name: "Flameproof Tube Light Fittings",
    description: "LED tube light fittings for hazardous environments, single and double configurations.",
    features: ["Up to 2x40W LED", "Zone 1 & 2", "Gas Group IIA, IIB & IIC", "IP66 Protection", "Energy Efficient"],
    image: "https://customer-assets.emergentagent.com/job_sai-electrical/artifacts/cjmcslmm_WhatsApp_Image_2024-04-16_at_17.50.22-removebg-preview%20%282%29.png",
    catNo: "SAI/3004"
  },
  {
    id: 7,
    name: "Flameproof Fans",
    description: "Explosion-proof exhaust, ceiling, wall mounting and pedestal fans for hazardous locations.",
    features: ["Multiple Types", "Zone 1 & 2", "Gas Group IIA, IIB & IIC", "IP66 Protection", "Various Mounting Options"],
    image: "https://customer-assets.emergentagent.com/job_sai-electrical/artifacts/0m6sltty_Pedestal-Fan.png",
    catNo: "SAI/202"
  },
  {
    id: 8,
    name: "Flameproof DOL & Star Delta Starters",
    description: "Motor starters for hazardous areas with capacity from 0.5 HP to 40 HP.",
    features: ["0.5 HP to 40 HP", "Zone 1 & 2", "Gas Group IIA & IIB", "IP65 Protection", "Reliable Operation"],
    image: "https://customer-assets.emergentagent.com/job_sai-electrical/artifacts/sxy1h048_IMG-20230521-WA0034-PhotoRoom.png-PhotoRoom.png",
    catNo: "SAI/CS/1051"
  }
];

export const productCategories = [
  {
    id: 1,
    name: "Flameproof Lighting Solutions",
    slug: "lighting",
    description: "LED floodlights, well glass lights, and tube fittings for hazardous areas",
    icon: "Lightbulb",
    productIds: [1, 6]
  },
  {
    id: 2,
    name: "Flameproof Junction Boxes",
    slug: "junction-boxes",
    description: "Flameproof terminal and junction boxes for various applications",
    icon: "Box",
    productIds: [2]
  },
  {
    id: 3,
    name: "Flameproof Control Stations & Panels",
    slug: "control-stations",
    description: "Push button stations, control panels, and local control stations",
    icon: "Gauge",
    productIds: [3, 4]
  },
  {
    id: 4,
    name: "Flameproof Switches & Sockets",
    slug: "switches-sockets",
    description: "Explosion-proof switches, sockets, and electrical connections",
    icon: "Plug",
    productIds: [5]
  },
  {
    id: 5,
    name: "Flameproof Ventilation Equipment",
    slug: "ventilation",
    description: "Flameproof fans for exhaust, ceiling, wall, and pedestal mounting",
    icon: "Fan",
    productIds: [7]
  },
  {
    id: 6,
    name: "Flameproof Motor Starters",
    slug: "motor-starters",
    description: "DOL and Star Delta starters for motors up to 40 HP",
    icon: "Zap",
    productIds: [8]
  }
];

export const industries = [
  {
    id: 1,
    name: "Oil & Gas",
    description: "Comprehensive solutions for upstream, midstream, and downstream operations.",
    icon: "Flame",
    image: "https://images.unsplash.com/photo-1660446718081-d2ac1e7985ba?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzN8MHwxfHNlYXJjaHwxfHxvaWwlMjBnYXMlMjByZWZpbmVyeSUyMGluZHVzdHJpYWwlMjBzdW5zZXR8ZW58MHx8fHwxNzc3MzY4MzEyfDA&ixlib=rb-4.1.0&q=85"
  },
  {
    id: 2,
    name: "Chemical & Petrochemical",
    description: "Specialized equipment for chemical processing and manufacturing facilities.",
    icon: "FlaskConical",
    image: "https://images.unsplash.com/photo-1768128834406-f5b1b962af9d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1OTV8MHwxfHNlYXJjaHwxfHxjaGVtaWNhbCUyMHBsYW50JTIwZmFjdG9yeSUyMGluZHVzdHJpYWx8ZW58MHx8fHwxNzc3MzY4MzE0fDA&ixlib=rb-4.1.0&q=85"
  },
  {
    id: 3,
    name: "Pharmaceuticals",
    description: "Clean room compatible solutions for pharmaceutical manufacturing.",
    icon: "Pill",
    image: "https://images.unsplash.com/photo-1748349221526-33b51820b21e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNDR8MHwxfHNlYXJjaHwyfHxwaGFybWFjZXV0aWNhbCUyMG1hbnVmYWN0dXJpbmclMjBjbGVhbiUyMHJvb218ZW58MHx8fHwxNzc3MzY4MzE0fDA&ixlib=rb-4.1.0&q=85"
  },
  {
    id: 4,
    name: "Mining",
    description: "Rugged equipment designed for harsh underground mining conditions.",
    icon: "HardHat",
    image: "https://images.unsplash.com/photo-1769240628173-155c849658cc?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzh8MHwxfHNlYXJjaHwxfHxtaW5pbmclMjBlcXVpcG1lbnQlMjBpbmR1c3RyaWFsfGVufDB8fHx8MTc3NzM2ODMxNXww&ixlib=rb-4.1.0&q=85"
  },
  {
    id: 5,
    name: "Power Generation",
    description: "Reliable electrical solutions for power plants and substations.",
    icon: "Zap",
    image: "https://images.unsplash.com/photo-1776251896448-a5eb8ae25e35?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDJ8MHwxfHNlYXJjaHwxfHxwb3dlciUyMGdlbmVyYXRpb24lMjBwbGFudCUyMGVsZWN0cmljYWx8ZW58MHx8fHwxNzc3MzY4MzE2fDA&ixlib=rb-4.1.0&q=85"
  },
  {
    id: 6,
    name: "Manufacturing",
    description: "Industrial-grade equipment for diverse manufacturing environments.",
    icon: "Factory",
    image: "https://images.unsplash.com/photo-1764835994645-3faa2c40f708?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1Mjh8MHwxfHNlYXJjaHwxfHxtYW51ZmFjdHVyaW5nJTIwZmFjdG9yeSUyMGluZHVzdHJpYWwlMjBhdXRvbWF0aW9ufGVufDB8fHx8MTc3NzM2ODMxN3ww&ixlib=rb-4.1.0&q=85"
  }
];

export const certifications = [
  {
    id: 1,
    name: "BIS Approved",
    description: "Bureau of Indian Standards certification for quality assurance",
    logo: "https://customer-assets.emergentagent.com/job_sai-electrical/artifacts/4u4k3q22_2021-07-28_052111.8631470000.jpg"
  },
  {
    id: 2,
    name: "ISO 9001:2015",
    description: "Quality Management System Certification",
    logo: "https://customer-assets.emergentagent.com/job_sai-electrical/artifacts/aba7uh4b_9001.jpg"
  },
  {
    id: 3,
    name: "ISO 45001:2018",
    description: "Occupational Health and Safety Management System",
    logo: "https://customer-assets.emergentagent.com/job_sai-electrical/artifacts/i8fzwn6w_Screenshot%202026-04-28%20134944.jpg"
  },
  {
    id: 4,
    name: "ISO 14001:2015",
    description: "Environmental Management System Certification",
    logo: "https://customer-assets.emergentagent.com/job_sai-electrical/artifacts/mx3ls8q7_Screenshot%202026-04-28%20134909.jpg"
  },
  {
    id: 5,
    name: "CIMFR Certified",
    description: "Central Institute of Mining & Fuel Research certification for mining safety",
    logo: "https://customer-assets.emergentagent.com/job_sai-electrical/artifacts/vll7ntdj_CIMFR.jpg"
  },
  {
    id: 6,
    name: "PESO Certified",
    description: "Petroleum and Explosives Safety Organisation approval",
    logo: "https://customer-assets.emergentagent.com/job_sai-electrical/artifacts/boga7wde_PESO.jpg"
  },
  {
    id: 7,
    name: "EIL Enlisted",
    description: "Engineers India Limited approval for engineering excellence",
    logo: "https://customer-assets.emergentagent.com/job_sai-electrical/artifacts/ob4e6kwp_Logo.png"
  },
  {
    id: 8,
    name: "Make in India",
    description: "Proudly manufactured in India supporting Atmanirbhar Bharat",
    logo: "https://customer-assets.emergentagent.com/job_sai-electrical/artifacts/4cvqrek4_thequint_2016-01_5fe4b302-c270-4b8a-8c02-db7cf3ef93ed_Make-in-India.webp"
  },
  {
    id: 9,
    name: "GeM Registered",
    description: "Government e-Marketplace (GeM) Registered Vendor",
    logo: "https://customer-assets.emergentagent.com/job_sai-electrical/artifacts/xut5y4g5_GeM%20New%20Logo.jpg.jpeg"
  }
];

export const features = [
  {
    id: 1,
    title: "Expert Engineering",
    description: "Decades of experience in designing flameproof electrical solutions",
    icon: "Wrench"
  },
  {
    id: 2,
    title: "Quality Assurance",
    description: "Rigorous testing and quality control at every stage",
    icon: "Shield"
  },
  {
    id: 3,
    title: "Custom Solutions",
    description: "Tailored products to meet specific industry requirements",
    icon: "Settings"
  },
  {
    id: 4,
    title: "Safety First",
    description: "Uncompromising commitment to safety standards and compliance",
    icon: "ShieldCheck"
  },
  {
    id: 5,
    title: "Fast Delivery",
    description: "Efficient manufacturing and timely project completion",
    icon: "Truck"
  },
  {
    id: 6,
    title: "Technical Support",
    description: "Comprehensive after-sales service and technical assistance",
    icon: "Headphones"
  }
];

export const stats = [
  { label: "Years Experience", value: "30+", number: 30, icon: "Calendar" },
  { label: "Products Delivered", value: "50,000+", number: 50000, icon: "Package" },
  { label: "Industries Served", value: "100+", number: 100, icon: "Building2" },
  { label: "Certified Products", value: "100%", number: 100, icon: "Award", suffix: "%" }
];

export const clients = [
  // Oil & Gas Sector First (as requested)
  {
    id: 1,
    name: "Indian Oil Corporation",
    logo: "https://customer-assets.emergentagent.com/job_sai-electrical/artifacts/bi23umw9_Indian_Oil_Corporation-Logo.wine.png",
    description: "India's largest commercial enterprise"
  },
  {
    id: 2,
    name: "HPCL - Hindustan Petroleum Corporation",
    logo: "https://customer-assets.emergentagent.com/job_sai-electrical/artifacts/6p6e9adu_Hindustan_Petroleum-Logo.wine.svg",
    description: "Major petroleum refining company"
  },
  {
    id: 3,
    name: "Bharat Petroleum Corporation",
    logo: "https://customer-assets.emergentagent.com/job_sai-electrical/artifacts/dytkm471_Bharat_Petroleum-Logo.wine.png",
    description: "Petroleum & energy"
  },
  {
    id: 4,
    name: "ONGC - Oil and Natural Gas Corporation",
    logo: "https://customer-assets.emergentagent.com/job_sai-electrical/artifacts/gqthj987_Oil_and_Natural_Gas_Corporation-Logo.wine.png",
    description: "Oil & gas exploration"
  },
  {
    id: 5,
    name: "GAIL - Gas Authority of India Limited",
    logo: "https://customer-assets.emergentagent.com/job_sai-electrical/artifacts/r8c5g864_Gail.png",
    description: "Natural gas transmission"
  },
  // Other Major Clients
  {
    id: 6,
    name: "SAIL - Steel Authority of India",
    logo: "https://customer-assets.emergentagent.com/job_sai-electrical/artifacts/akqj03f4_Sail.jpg",
    description: "India's largest steel producer"
  },
  {
    id: 6,
    name: "BHEL - Bharat Heavy Electricals",
    logo: "https://customer-assets.emergentagent.com/job_sai-electrical/artifacts/ppngr4a9_Bharat_Heavy_Electricals_Limited-Logo.wine.png",
    description: "Power & industrial equipment"
  },
  {
    id: 7,
    name: "NPCIL - Nuclear Power Corporation",
    logo: "https://customer-assets.emergentagent.com/job_sai-electrical/artifacts/f77zutxn_NPCIL_Logo.svg.png",
    description: "Nuclear power generation"
  },
  {
    id: 8,
    name: "Bhabha Atomic Research Centre",
    logo: "https://customer-assets.emergentagent.com/job_sai-electrical/artifacts/3tzkeb1a_Bhabha_Atomic_Research_Centre_Logo.png",
    description: "Nuclear research excellence"
  },
  {
    id: 9,
    name: "Bajaj Electricals",
    logo: "https://customer-assets.emergentagent.com/job_sai-electrical/artifacts/yqz3taeu_Bajaj_Electricals_logo.jpg",
    description: "Trusted electrical solutions"
  },
  {
    id: 10,
    name: "Munitions India Limited",
    logo: "https://customer-assets.emergentagent.com/job_sai-electrical/artifacts/80bb4wf5_56c564df5f0bcf9bdd755215f57098a4.png",
    description: "Leading defense manufacturer"
  },
  {
    id: 11,
    name: "BCPL - Brahmaputra Cracker and Polymer Limited",
    logo: "https://customer-assets.emergentagent.com/job_sai-electrical/artifacts/562lrycd_bcpl_logo.png",
    description: "Petrochemical excellence"
  },
  {
    id: 12,
    name: "HOCL - Hindustan Organic Chemicals Limited",
    logo: "https://customer-assets.emergentagent.com/job_sai-electrical/artifacts/n2l2cwds_logo.png",
    description: "Chemical manufacturing"
  },
  {
    id: 13,
    name: "CPCL - Chennai Petroleum Corporation",
    logo: "https://customer-assets.emergentagent.com/job_sai-electrical/artifacts/01b44c19_images.png",
    description: "Petroleum refining"
  },
  {
    id: 14,
    name: "National Fertilizers Limited",
    logo: "https://customer-assets.emergentagent.com/job_sai-electrical/artifacts/8w5903ai_images%20%282%29.png",
    description: "Agriculture & chemicals"
  },
  {
    id: 15,
    name: "NMDC Steel",
    logo: "https://customer-assets.emergentagent.com/job_sai-electrical/artifacts/6w1qp10a_images%20%281%29.png",
    description: "Steel manufacturing leader"
  },
  {
    id: 16,
    name: "HWB",
    logo: "https://customer-assets.emergentagent.com/job_sai-electrical/artifacts/mzan2n56_images.jpg",
    description: "Heavy Water Board"
  },
  {
    id: 17,
    name: "NHDC",
    logo: "https://customer-assets.emergentagent.com/job_sai-electrical/artifacts/hvfcozvt_images.png",
    description: "National Hydroelectric Power Corporation"
  },
  {
    id: 18,
    name: "FACT",
    logo: "https://customer-assets.emergentagent.com/job_sai-electrical/artifacts/qheikl00_fertilisers_and_chemicals_travancore_limited_logo.jpg",
    description: "Fertilisers and Chemicals Travancore Limited"
  },
  {
    id: 19,
    name: "NRL",
    logo: "https://customer-assets.emergentagent.com/job_sai-electrical/artifacts/9skxs32t_nrl-og-logo.png",
    description: "Numaligarh Refinery Limited"
  },
  {
    id: 20,
    name: "AAI - Airports Authority of India",
    logo: "https://customer-assets.emergentagent.com/job_sai-electrical/artifacts/n2nq8a44_AAI.webp",
    description: "Airports Authority of India"
  },
  {
    id: 21,
    name: "Oil India Limited",
    logo: "https://customer-assets.emergentagent.com/job_sai-electrical/artifacts/ec6vrvgl_OILLOGOWITHBACKGROUND.png",
    description: "Oil & gas exploration and production"
  },
  {
    id: 22,
    name: "HURL - Hindustan Urvarak & Rasayan Limited",
    logo: "https://customer-assets.emergentagent.com/job_sai-electrical/artifacts/9bn09tsp_apna_urea_logo.jpg",
    description: "Fertilizer & chemicals manufacturer"
  }
];
